"use client";

import { useEffect, useRef } from "react";
import { Text, Text as MantineText } from "@mantine/core";
import { CountUp } from "countup.js";
import { useImageSearchStore } from "@/stores/imageSearchStore";

const ImageSearchCount: React.FC = () => {
  const total = useImageSearchStore((state) => state.total);
  const items = useImageSearchStore((state) => state.items);
  const loading = useImageSearchStore((state) => state.loading);
  const countUpRef = useRef<HTMLSpanElement | null>(null);
  const countUpInstance = useRef<CountUp | null>(null);
  const lastValidCount = useRef<number>(0);

  const rawCount = total ?? items.length;

  // During loading, keep showing the last valid count
  const displayCount = loading && rawCount === 0 ? lastValidCount.current : rawCount;

  // Remember the last valid count
  if (displayCount > 0) {
    lastValidCount.current = displayCount;
  }

  const showPlus = (total ?? 0) >= 500;

  useEffect(() => {
    if (!countUpRef.current || displayCount <= 0) {
      return;
    }

    if (!countUpInstance.current) {
      countUpInstance.current = new CountUp(countUpRef.current, displayCount, {
        duration: 1.2,
        separator: ",",
      });

      if (!countUpInstance.current.error) {
        countUpInstance.current.start();
      } else {
        console.error(countUpInstance.current.error);
      }
    } else {
      countUpInstance.current.update(displayCount);
    }
  }, [displayCount]);

  if (displayCount <= 0) {
    return null;
  }

  return (
    <Text size="xs">
      <MantineText component="span" ref={countUpRef}></MantineText>
      {showPlus && "+"} similar items
    </Text>
  );
};

export default ImageSearchCount;
